import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { MarketdateExpense } from './marketdate-expense.model';
import { MarketdateExpensePopupService } from './marketdate-expense-popup.service';
import { MarketdateExpenseService } from './marketdate-expense.service';

@Component({
    selector: 'jhi-marketdate-expense-delete-dialog',
    templateUrl: './marketdate-expense-delete-dialog.component.html'
})
export class MarketdateExpenseDeleteDialogComponent {

    marketdateExpense: MarketdateExpense;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private marketdateExpenseService: MarketdateExpenseService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketdateExpense', 'expenseType']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.marketdateExpenseService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'marketdateExpenseListModification',
                content: 'Deleted an marketdateExpense'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-marketdate-expense-delete-popup',
    template: ''
})
export class MarketdateExpenseDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdateExpensePopupService: MarketdateExpensePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.marketdateExpensePopupService
                .open(MarketdateExpenseDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-expense/marketdate-expense-delete-dialog.component.ts